import React, { FC, useMemo } from 'react';
import { Redirect, Switch, useRouteMatch } from 'react-router';
import { PrivateRoute } from 'common/AuthRoute';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { BusinessPartnerPage } from 'pages/BusinessPartnerManagement/BusinessPartnerPage';
import { BusinessPartnerRoutes } from 'pages/BusinessPartnerManagement/businessPartnerRoutes';
import { BusinessPartnerUsersManagement } from 'pages/BusinessPartnerManagement/BusinessPartnerProfileOwnersManagement';
import { BusinessPartnerDoctorsManagement } from 'pages/BusinessPartnerManagement/BusinessPartnerDoctorsManagement';
import { BusinessPartnerDevicesManagement } from 'pages/BusinessPartnerManagement/BusinessPartnerDevicesManagement';
import { BusinessPartnerAdminsManagement } from 'pages/BusinessPartnerManagement/BusinessPartnerAdminsManagement';
import { BusinessPartnerSubpartnersManagement } from 'pages/BusinessPartnerManagement/BusinessPartnerSubpartnersManagement';
import { BusinessPartnerCtx } from 'models/businessPartner';
import { BusinessPartnerPatientsManagement } from 'pages/BusinessPartnerManagement/BusinessPartnerPatientsManagement';
import { BusinessPartnerMedicalOperatorsManagement } from 'pages/BusinessPartnerManagement/BusinessPartnerMedicalOperatorsManagement';
import { BusinessPartnerAdditionalDevicesManagement } from 'pages/BusinessPartnerManagement/BusinessPartnerAdditionalDevicesManagement';
import {
  ModuleContext,
  ModuleContextProvider,
} from 'common/ModuleContextProvider';

// todo: think about merging both context into one
export interface BusinessPartnerManagementRouterProps {
  moduleCtx: ModuleContext;
  businessPartnerCtx: BusinessPartnerCtx;
}
export const BusinessPartnerManagementRouter: FC<BusinessPartnerManagementRouterProps> = ({
  moduleCtx,
  businessPartnerCtx,
}) => {
  const { path } = useRouteMatch();
  const pathPrefix = useMemo(() => path.replace(/\/$/, ''), [path]);

  return (
    <ModuleContextProvider ctx={moduleCtx}>
      <BusinessPartnerContext.Provider value={businessPartnerCtx}>
        <Switch>
          <PrivateRoute
            exact
            path={`${path}`}
            component={BusinessPartnerPage}
          />

          <PrivateRoute
            path={`${pathPrefix}/${BusinessPartnerRoutes.Devices}`}
            component={BusinessPartnerDevicesManagement}
          />

          <PrivateRoute
            path={`${pathPrefix}/${BusinessPartnerRoutes.AdditionalDevices}`}
            component={BusinessPartnerAdditionalDevicesManagement}
          />

          <PrivateRoute
            path={`${pathPrefix}/${BusinessPartnerRoutes.MyPartners}`}
            component={BusinessPartnerSubpartnersManagement}
          />
          <PrivateRoute
            path={`${pathPrefix}/${BusinessPartnerRoutes.Admins}`}
            component={BusinessPartnerAdminsManagement}
          />

          <PrivateRoute
            path={`${pathPrefix}/${BusinessPartnerRoutes.Doctors}`}
            component={BusinessPartnerDoctorsManagement}
          />

          <PrivateRoute
            path={`${pathPrefix}/${BusinessPartnerRoutes.FamilyUsers}`}
            component={BusinessPartnerUsersManagement}
          />
          <PrivateRoute
            path={`${pathPrefix}/${BusinessPartnerRoutes.Patients}`}
            component={BusinessPartnerPatientsManagement}
          />
          <PrivateRoute
            path={`${pathPrefix}/${BusinessPartnerRoutes.MedicalOperators}`}
            component={BusinessPartnerMedicalOperatorsManagement}
          />

          <Redirect to={`${pathPrefix}`} />
        </Switch>
      </BusinessPartnerContext.Provider>
    </ModuleContextProvider>
  );
};
